import "aos/dist/aos.css";
import { useRef } from "react";
import { ExternalLink } from "lucide-react";

const HeroSection = () => {
  const videoRef = useRef(null);

  const handleMouseEnter = () => {
    if (videoRef.current) {
      videoRef.current.muted = false; // Turn on sound
      videoRef.current.volume = 1.0;
    }
  };

  const handleMouseLeave = () => {
    if (videoRef.current) {
      videoRef.current.muted = true; // Turn off sound
    }
  };

  return (
    <>
      <section className="px-4 sm:px-6 md:px-[5%] py-8 bg-white">
        <div className="relative max-w-7xl mx-auto overflow-hidden rounded-3xl md:rounded-[40px]">
          {/* Video Background */}
          <video
            ref={videoRef}
            className="w-full h-[60vh] sm:h-[70vh] md:h-[80vh] object-cover rounded-3xl md:rounded-[40px] transition duration-300"
            autoPlay
            loop
            muted
            playsInline
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <source
              src="http://media.w3.org/2010/05/sintel/trailer.mp4"
              type="video/mp4"
            />
          </video>

          {/* Overlay Text */}
          <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6 md:px-16 bg-gradient-to-t from-black/50 via-transparent to-transparent rounded-3xl md:rounded-[40px]"
          >
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4">
              Empowering Education with{" "}
              <span className="text-[#0d6b68]">EduLynks</span>
            </h2>
            <p className="max-w-2xl text-sm sm:text-base md:text-lg text-gray-200 mb-6">
              Discover how EduLynks transforms institutions into digital
              ecosystems with smart analytics, real-time tracking, and seamless
              collaboration.
            </p>
            <a
              href="tel:+917994670962"
              className="btn1 group inline-flex items-center gap-3"
            >
              <span className="font-medium transition">Get in Touch</span>
              <ExternalLink className="w-4 h-4 transition-transform group-hover:translate-x-1 duration-200" />
            </a>
          </div>
        </div>
      </section>

      <section className="px-[5%]">
        {/* <!-- Hero Section --> */}
        <div className="max-w-7xl mx-auto my-14 bg-[#0d6b68] grid grid-cols-1 lg:grid-cols-2 gap-6 items-center p-6 rounded-[40px]">
          {/* <!-- Text Column --> */}
          <div className="">
            <p className="text-4xl font-bold text-gray-900">
              EduLynks for Students
            </p>
            <h2 className="text-2xl md:text-4xl font-bold mt-2 mb-3 text-white">
              Empowering Education Through Smart Technology
            </h2>

            <h3 className="text-lg text-white mt-4">
              Edulynks transforms how schools and universities operate with
              intelligent dashboards that simplify management, enhance learning,
              and optimize time. From MIS and LMS to AI-powered timetabling, we
              deliver tailored solutions from setup to analytics built for
              modern education.
            </h3>
            <div className="flex flex-wrap gap-4 mt-4">
              <a
                href="tel:+917994670962"
                className="btn1 group inline-flex items-center gap-3"
              >
                <span className="font-medium transition">Try EduLynks</span>
                <ExternalLink className="w-4 h-4 transition-transform group-hover:translate-x-1 duration-200" />
              </a>
            </div>
          </div>
          <div className="relative group p-2 rounded-full">
            <img
              src="./images/student.png"
              alt="Student"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
